import { chatConstants } from '../constants';
import { chatService } from '../services';
import { showToast } from '../services/toast';

export const chatActions = {
    fetchChatMessages,
    sendChatMessage,
    updateChatMessages,
    appendChatMessages,
    reportChatMessage
};

function fetchChatMessages(classId) {
    return dispatch => {
        dispatch(request());

        chatService.fetchChatMessages(classId)
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: chatConstants.FETCH_CHATMESSAGES_REQUEST } }
    function success(chatmessages) { return { type: chatConstants.FETCH_CHATMESSAGES_SUCCESS, chatmessages } }
    function failure(error) { return { type: chatConstants.FETCH_CHATMESSAGES_FAILURE, error } }
}

function sendChatMessage(msg) {
    return dispatch => {
        dispatch(request());

        return chatService.sendChatMessage(msg)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    showToast(error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: chatConstants.SEND_CHATMESSAGE_REQUEST } }
    function success(chatmessages) { return { type: chatConstants.SEND_CHATMESSAGE_SUCCESS, chatmessages } }
    function failure(error) { return { type: chatConstants.SEND_CHATMESSAGE_FAILURE, error } }
}

function updateChatMessages(newMessages) {
    return dispatch => {
        dispatch({ type: chatConstants.UPDATE_CHATMESSAGES, chatmessages: newMessages });
    };
}

function appendChatMessages(newMessages) {
    return dispatch => {
        dispatch({ type: chatConstants.APPEND_CHATMESSAGES, chatmessages: newMessages });
    };
}

function reportChatMessage(reportMsg) {
    return dispatch => {
        return chatService.reportChatMessage(reportMsg)
            .then(
                response => {
                    return response;
                },
                error => {
                    showToast(error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };
}